// extracted by mini-css-extract-plugin
export default {"section":"ProtectedRoute_section__hA9Np"};